module.exports = __webpack_public_path__ + "static/media/car_top_view.ffe82b65.svg";